module.exports = __webpack_public_path__ + "img/wifi-check.36cea332.svg";